type GenericSequenceMap = {
  AWAY_DRAW_HOME: ['AWAY', 'DRAW', 'HOME'];
  AWAY_HOME: ['AWAY', 'HOME'];
  FIGHTER_1_DRAW_FIGHTER_2: ['FIGHTER_1', 'DRAW', 'FIGHTER_2'];
  FIGHTER_1_FIGHTER_2: ['FIGHTER_1', 'FIGHTER_2'];
  HOME_AWAY: ['HOME', 'AWAY'];
  HOME_DRAW_AWAY: ['HOME', 'DRAW', 'AWAY'];
  PLAYER_1_DRAW_PLAYER_2: ['PLAYER_1', 'DRAW', 'PLAYER_2'];
  PLAYER_1_PLAYER_2: ['PLAYER_1', 'PLAYER_2'];
  YES_NO: ['YES', 'NO'];
};

export type GenericSequenceKey = keyof GenericSequenceMap;

export const genericSequenceMap: GenericSequenceMap = {
  AWAY_DRAW_HOME: ['AWAY', 'DRAW', 'HOME'],
  AWAY_HOME: ['AWAY', 'HOME'],
  FIGHTER_1_DRAW_FIGHTER_2: ['FIGHTER_1', 'DRAW', 'FIGHTER_2'],
  FIGHTER_1_FIGHTER_2: ['FIGHTER_1', 'FIGHTER_2'],
  HOME_AWAY: ['HOME', 'AWAY'],
  HOME_DRAW_AWAY: ['HOME', 'DRAW', 'AWAY'],
  PLAYER_1_DRAW_PLAYER_2: ['PLAYER_1', 'DRAW', 'PLAYER_2'],
  PLAYER_1_PLAYER_2: ['PLAYER_1', 'PLAYER_2'],
  YES_NO: ['YES', 'NO'],
};
